import { Try } from "@/common";
import { Notify } from "quasar";
import { CreateUser, User } from "./user.service";
import { api } from "@/plugins";

export interface AuthUser {
  username: string;
  password: string;
  passwordConfirmation: string;
}

export interface AuthToken {
  token: string;
}

class AuthService {
  @Try({
    onError() {
      Notify.create({
        type: "negative",
        message: "Неверный логин или пароль",
        position: "top",
      });
    },
  })
  async signIn(authUser: AuthUser) {
    const { data } = await api.post<AuthToken>("/auth/sign-in", authUser);
    return data;
  }

  @Try()
  async signUp(user: CreateUser) {
    await api.post("/auth/sign-up", user);
    return true;
  }

  @Try()
  async signOut() {
    await api.post("/auth/sign-out");
    return true;
  }

  async me() {
    const { data } = await api.post<User>("/auth/me");
    return data;
  }
}

const authService = new AuthService();

export { authService as AuthService };
